module.exports = __webpack_public_path__ + "static/media/icon_187.68f4cf7f.svg";